<template>
	<div>
		<ListHeaderComponent :background="background" :black="true">
			<span slot="title">{{title}}</span>
		</ListHeaderComponent>
		<div class="empty-filter"></div>

		<section v-if="!activate" class="activate">
			<h2>{{$t('activation.headline')}}</h2>
			<h3>{{$t('activation.subheadline')}}</h3>
		</section>

		<section v-if="activate" class="activate">
			<h2>{{$t('activation.confirmation')}}</h2>
			<h3>{{$t('activation.sub')}}</h3>
		</section>
		<ContactComponent></ContactComponent>
		<PartnersComponent></PartnersComponent>
	</div>
</template>

<script>
	import ListHeaderComponent from '@/components/ListHeaderComponent'
	import ContactComponent from '@/components/ContactComponent'
	import PartnersComponent from '@/components/PartnersComponent'
	import axios from 'axios'

	export default {
		components: {
			ListHeaderComponent,
			ContactComponent,
			PartnersComponent
		},
		data () {
			return {
				title: 'Activate Account',
				background: 'account',
				activate: false
			}
		},
		methods: {
			activateAccount () {
				// this.clearErrors()
				let activationToken = {
					token: this.$route.query.token
				}
				axios.post('/api/user/activate/', activationToken, {})
					.then(resp => {
						this.activate = true
					})
					.catch(err => {
						console.log(err)
					})
			}
		},
		created () {
			this.activateAccount()
		}
	}
</script>

<style lang="scss" scoped>

	@import "../styles/variables.scss";

	.activate {
		padding: 60px 0;
	}

	.empty-filter {
		width: 100%;
		height: 35px;
		background-color: $gold-light;
	}

</style>



// WEBPACK FOOTER //
// src/views/Activate.vue